import { cnpjConfig } from "@utils/fiscal/cnpj/config";

const CNPJ_LENGTH = 14;
// const CNPJ_MASK = "##.###.###/####-##";
export const invalidCNPJ = "CNPJ com formato invalido";

export const normalizeCnpj = (value = "", allow = false): string => {
  const pattern = allow ? /[^a-zA-Z0-9]/g : /\D/g;
  return value.replace(pattern, "").toUpperCase().slice(0, CNPJ_LENGTH);
};

export const extractCnpj = (value: string): string => {
  if (!value) return "";

  const lastPart = value.split("|").pop()?.trim() ?? "";

  const match =
    lastPart.match(
      /[A-Z0-9]{2,3}\.[A-Z0-9]{3}\.[A-Z0-9]{2,3}\/[A-Z0-9]{4}-[A-Z0-9]{2}/i
    )?.[0] ?? "";

  return match.replace(/[^A-Z0-9]/gi, "").toUpperCase();
};

export const formatCnpj = (value: string): string => {
  const cleaned = unmaskCnpj(value).slice(0, CNPJ_LENGTH);

  if (!cleaned) return "";
  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 5) return `${cleaned.slice(0, 2)}.${cleaned.slice(2)}`;
  if (cleaned.length <= 8) {
    return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5)}`;
  }
  if (cleaned.length <= 12) {
    return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(
      5,
      8
    )}/${cleaned.slice(8)}`;
  }

  return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(
    5,
    8
  )}/${cleaned.slice(8, 12)}-${cleaned.slice(12, 14)}`;
};

export const maskCNPJAlfa = (
  value = "",
  allow = cnpjConfig.allowAlphanumeric
): string => {
  return formatCnpj(normalizeCnpj(value, allow));
};

export const unmaskCnpj = (value: string): string => {
  const pattern = cnpjConfig.allowAlphanumeric ? /[^a-zA-Z0-9]/g : /\D/g;
  return value.replace(pattern, "").toUpperCase();
};
